import { Switch } from '@mui/material';
import { useState } from 'react';
import { useSelector } from 'react-redux';

const EditarSeguimientoPedido = ({
    envio,
    register,
    errors,
    setValue,
    watch,
    getValues,
    unregister
}) => {
    const [changeTransportista, setChangeTransportista] = useState(false);

    const transportistas = useSelector((state) => {
        return state.transportistas;
    });
    const serviciosEnvio = useSelector((state) => {
        return state.servicios_envio;
    });

    const handleChangeTransportista = (e) => {
        const checked = e.target.checked;
        setChangeTransportista(checked);

        if (!checked) {
            unregister(`envios.${envio.id}.transportista_id`, '');
            unregister(`envios.${envio.id}.servicio_envio_id`, '');
        }
    };

    return (
        <div className="w-100 d-flex flex-column">
            <div className="w-100 d-flex align-items-center">
                <Switch
                    color="success"
                    value={changeTransportista}
                    onChange={handleChangeTransportista}
                    inputProps={{ 'aria-label': 'controlled' }}
                />
                <label>Cambio de transportista?</label>
            </div>

            <div>
                <div className="w-100">
                    {envio.transportista_id === 1 && (
                        <>
                            <div className="form-group mb-0">
                                <label htmlFor="url_seguimiento">
                                    URL de seguimiento:
                                </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    {...register(
                                        `envios.${envio.id}.url_seguimiento`
                                    )}
                                />
                            </div>

                            <div className="form-invalid">
                                {errors.envios?.[envio.id]?.url_seguimiento &&
                                    'La URL de seguimiento es obligatoria'}
                            </div>
                        </>
                    )}
                </div>
                <div className="w-100">
                    <div className="form-group mb-0 mt-3">
                        <label htmlFor="numero_seguimiento">
                            Número de seguimiento:
                        </label>
                        <input
                            type="text"
                            className="form-control"
                            {...register(
                                `envios.${envio.id}.numero_seguimiento`
                            )}
                        />
                    </div>
                    <div className="form-invalid">
                        {errors.envios?.[envio.id]?.numero_seguimiento &&
                            'El número de seguimiento es obligatorio'}
                    </div>
                </div>
            </div>

            {changeTransportista && (
                <div className="mt-4">
                    <div className="form-group">
                        <label>Nuevo transportista:</label>
                        <select
                            id={`envios.${envio.id}.transportista_id`}
                            defaultValue={envio.transportista_id}
                            {...register(
                                `envios.${envio.id}.transportista_id`,
                                { required: true }
                            )}
                            onChange={(e) =>
                                setValue(
                                    `envios.${envio.id}.transportista_id`,
                                    e.target.value
                                )
                            }
                        >
                            {transportistas?.map((op) => (
                                <option
                                    key={'transportista-' + op.id}
                                    value={op.id}
                                >
                                    {op.nombre}
                                </option>
                            ))}
                        </select>
                    </div>
                    {watch(`envios.${envio.id}.transportista_id`) && (
                        <div className="form-group">
                            <label>Nuevo servicio de envío:</label>
                            <select
                                id={`envios.${envio.id}.servicio_envio_id`}
                                defaultValue={envio.servicio_envio_id}
                                {...register(
                                    `envios.${envio.id}.servicio_envio_id`,
                                    { required: true }
                                )}
                                onChange={(e) =>
                                    setValue(
                                        `envios.${envio.id}.servicio_envio_id`,
                                        e.target.value
                                    )
                                }
                            >
                                {serviciosEnvio
                                    .filter(
                                        (sv) =>
                                            sv.transportista_id ==
                                            getValues(
                                                `envios.${envio.id}.transportista_id`
                                            )
                                    )
                                    ?.map((op) => (
                                        <option
                                            key={'servicioenvio-' + op.id}
                                            value={op.id}
                                        >
                                            {op.nombre}
                                        </option>
                                    ))}
                            </select>
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};

export default EditarSeguimientoPedido;
